import { useEffect, useRef, type RefObject } from 'react';

/**
 * Смена ширины элемента (ResizeObserver; высота не интересует). Колбэк приходит
 * после раскладки и до отрисовки кадра: правка в нём — число колонок, позиция
 * скролла — не даёт промежуточного кадра.
 */
export function useResizeWidth(
  ref: RefObject<HTMLElement | null>,
  onChange: (width: number) => void,
): void {
  const handler = useRef(onChange);
  handler.current = onChange;

  useEffect(() => {
    const element = ref.current;
    if (!element || typeof ResizeObserver === 'undefined') return;
    let last = -1;
    const observer = new ResizeObserver((entries) => {
      const width = entries[entries.length - 1]?.contentRect.width;
      if (width === undefined || width === last) return;
      last = width;
      handler.current(width);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref]);
}
